// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3dGJx","field":"styles_field__2Jjk8","fieldCol":"styles_fieldCol__1xBgc","diffCol":"styles_diffCol__3saXW","diff":"styles_diff__3CAug"};